import { AsyncPipe } from '@angular/common';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

import {
  Component,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FuseLoadingService } from '@fuse/services/loading';
import { combineLatest, map, Observable } from 'rxjs';

interface LoadingBarViewModel {
  show: boolean;
  mode: 'determinate' | 'indeterminate';
  progress: number;
}

@Component({
  selector: 'fuse-loading-bar',
  templateUrl: './loading-bar.component.html',
  styleUrls: ['./loading-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  exportAs: 'fuseLoadingBar',
  standalone: true,
  imports: [MatProgressBarModule, AsyncPipe]
})
export class FuseLoadingBarComponent implements OnChanges, OnDestroy {
  private _fuseLoadingService = inject(FuseLoadingService);

  @Input() autoMode: boolean = true;

  /** Async pipe evita NG0100 al sincronizar con el interceptor HTTP en el mismo tick. */
  readonly vm$: Observable<LoadingBarViewModel> = combineLatest([
    this._fuseLoadingService.show$,
    this._fuseLoadingService.mode$,
    this._fuseLoadingService.progress$
  ]).pipe(
    map(([show, mode, progress]) => ({
      show,
      mode,
      progress: progress ?? 0
    }))
  );

  ngOnChanges(changes: SimpleChanges): void {
    if ('autoMode' in changes) {
      this._fuseLoadingService.setAutoMode(coerceBooleanProperty(changes.autoMode.currentValue));
    }
  }

  ngOnDestroy(): void {}
}
